import { Subscription } from '../services/models/subscription';
import { useAccount } from './useAccount';

// DashboardApp gates rendering on the account being loaded, so consumers
// normally always see a real subscription; the empty fallback keeps a
// transient account-less render (e.g. viewer refetch after an error) from
// crashing on `subscription.<field>` dereferences.
export const useSubscription = (): Subscription => {
  const { account } = useAccount();
  return account?.subscription ?? ({} as Subscription);
};
